import React from 'react';

const PackageIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">
                        deployed_code
                  </span>
            </>
      );
};

export default PackageIcon;
